// The phone's design tokens (@battleops/client/src/theme/tokens.js) as CSS custom properties — one source of
// truth for both apps. Injected before the first render (main.jsx).
import { color, space, font } from '@battleops/client/src/theme/tokens';

const kebab = (k) => k.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

export function tokenCss() {
  const lines = [];
  for (const [k, v] of Object.entries(color)) lines.push(`--c-${kebab(k)}: ${v};`);
  for (const [k, v] of Object.entries(space)) lines.push(`--sp-${k}: ${v}px;`);
  for (const [k, v] of Object.entries(font.size)) lines.push(`--fs-${k}: ${v}px;`);
  return `:root{${lines.join('')}}`;
}

export function injectTokens() {
  const el = document.createElement('style');
  el.id = 'ops-tokens';
  el.textContent = tokenCss();
  document.head.prepend(el);
}
